module.exports = __webpack_public_path__ + "242f6a03d7e73dffb133d3e50e30c88f.mp3";